var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1738_18250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1738_18250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1738_18250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46992 15.2799C9.27992 15.2799 9.08992 15.2099 8.93992 15.0599C8.11992 14.2399 7.66992 13.1499 7.66992 11.9999C7.66992 9.60992 9.60992 7.66992 11.9999 7.66992C13.1499 7.66992 14.2399 8.11992 15.0599 8.93992C15.1999 9.07992 15.2799 9.26992 15.2799 9.46992C15.2799 9.66992 15.1999 9.85992 15.0599 9.99992L9.99992 15.0599C9.84992 15.2099 9.65992 15.2799 9.46992 15.2799ZM11.9999 9.16992C10.4399 9.16992 9.16992 10.4399 9.16992 11.9999C9.16992 12.4999 9.29992 12.9799 9.53992 13.3999L13.3999 9.53992C12.9799 9.29992 12.4999 9.16992 11.9999 9.16992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59984 18.5105C5.42984 18.5105 5.24984 18.4505 5.10984 18.3305C4.03984 17.4205 3.07984 16.3005 2.25984 15.0005C1.19984 13.3505 1.19984 10.6605 2.25984 9.00047C4.69984 5.18047 8.24984 2.98047 11.9999 2.98047C14.1999 2.98047 16.3699 3.74047 18.2699 5.17047C18.5999 5.42047 18.6699 5.89047 18.4199 6.22047C18.1699 6.55047 17.6999 6.62047 17.3699 6.37047C15.7299 5.13047 13.8699 4.48047 11.9999 4.48047C8.76984 4.48047 5.67984 6.42047 3.51984 9.81047C2.76984 10.9805 2.76984 13.0205 3.51984 14.1905C4.26984 15.3605 5.12984 16.3705 6.07984 17.1905C6.38984 17.4605 6.42984 17.9305 6.15984 18.2505C6.01984 18.4205 5.80984 18.5105 5.59984 18.5105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9986 21.0195C10.6686 21.0195 9.3686 20.7495 8.1186 20.2195C7.7386 20.0595 7.5586 19.6195 7.7186 19.2395C7.8786 18.8595 8.3186 18.6795 8.6986 18.8395C9.7586 19.2895 10.8686 19.5195 11.9886 19.5195C15.2186 19.5195 18.3086 17.5795 20.4686 14.1895C21.2186 13.0195 21.2186 10.9795 20.4686 9.80951C20.1586 9.31951 19.8186 8.84951 19.4586 8.40951C19.1986 8.08951 19.2486 7.61951 19.5686 7.34951C19.8886 7.08951 20.3586 7.12951 20.6286 7.45951C21.0186 7.93951 21.3986 8.45951 21.7386 8.99951C22.7986 10.6495 22.7986 13.3395 21.7386 14.9995C19.2986 18.8195 15.7486 21.0195 11.9986 21.0195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6896 16.2703C12.3396 16.2703 12.0196 16.0203 11.9496 15.6603C11.8696 15.2503 12.1396 14.8603 12.5496 14.7903C13.6496 14.5903 14.5696 13.6703 14.7696 12.5703C14.8496 12.1603 15.2396 11.9003 15.6496 11.9703C16.0596 12.0503 16.3296 12.4403 16.2496 12.8503C15.9296 14.5803 14.5496 15.9503 12.8296 16.2703C12.7796 16.2603 12.7396 16.2703 12.6896 16.2703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99945 22.7507C1.80945 22.7507 1.61945 22.6807 1.46945 22.5307C1.17945 22.2407 1.17945 21.7607 1.46945 21.4707L8.93945 14.0007C9.22945 13.7107 9.70945 13.7107 9.99945 14.0007C10.2894 14.2907 10.2894 14.7707 9.99945 15.0607L2.52945 22.5307C2.37945 22.6807 2.18945 22.7507 1.99945 22.7507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5287 10.2195C14.3387 10.2195 14.1488 10.1495 13.9988 9.99945C13.7088 9.70945 13.7088 9.22945 13.9988 8.93945L21.4687 1.46945C21.7587 1.17945 22.2388 1.17945 22.5288 1.46945C22.8188 1.75945 22.8188 2.23945 22.5288 2.52945L15.0588 9.99945C14.9088 10.1495 14.7187 10.2195 14.5287 10.2195Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1738_18250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEyeIcon);
export default __webpack_public_path__ + "static/media/close-eye-icon.1539bfd3b8782954ab5451604e2bff0f.svg";
export { ForwardRef as ReactComponent };